export { availableCdoByPos } from './cdo';